<template>
  <div class="main-video-container">
    <div class="main-video-header" v-if="showHeaders">
      שיעור {{ pos }} מתוך {{ len }} | <span>{{ video.pagetitle }}</span>
    </div>

    <main-video2
      :video="video"
      :base="initialData.basepath"
      :nextSeries="nextSeries"
      v-on:video-playing="showHeaders = false"
      v-on:video-ended="updateHistory()"
      v-on:load-next="$emit('load-next')"
      :isLast="isLast"
      v-if="video.kalturaId !== ''"
    ></main-video2>

    <main-video
      :video="video"
      :base="initialData.basepath"
      :nextSeries="nextSeries"
      v-on:video-playing="showHeaders = false"
      v-on:video-ended="updateHistory()"
      v-on:load-next="$emit('load-next')"
      :isLast="isLast"
      v-else
    ></main-video>

    <div class="columns main-video-desc">
      <div class="column is-half">
        <p>{{ video.description }}</p>
      </div>
      <div class="column is-half">
        <h5>
          <current-tag
            :current="current"
            :base="initialData.basepath"
            v-if="current"
          ></current-tag>
          <teacher-tag
            :teacher="teacher"
            :base="initialData.basepath"
            v-if="teacher"
          ></teacher-tag>
          | {{ level }} | {{ video.videoDuration }} דקות
        </h5>
        <p>{{ video.videoInfo }} {{ focus }}</p>

        <p>
          <equip-item
            :list="equipment"
            :base="initialData.basepath"
          ></equip-item>
        </p>
      </div>
    </div>
  </div>
  <!-- end main-video-container -->
</template>

<script>
import MainVideo from "@/components/video_page/MainVideo.vue";
import MainVideo2 from "@/components/video_page/MainVideo2.vue";
import TeacherTag from "@/components/TeacherTag.vue";
import CurrentTag from "@/components/CurrentTag.vue";
import EquipItem from "@/components/video_page/EquipItem.vue";

export default {
  name: `CurrentVideo`,
  props: {
    video: Object,
    initialData: Object,
    len: Number,
    pos: Number,
    isLast: {
      type: Boolean,
      default: false,
    },
    nextSeries: Number,
  },

  components: {
    MainVideo,
    MainVideo2,
    TeacherTag,
    CurrentTag,
    EquipItem,
  },

  data() {
    return {
      showHeaders: true,
    };
  },

  methods: {
    updateHistory() {
      this.showHeaders = true;
      this.$emit(`update-history`);
    },
  },

  computed: {
    current() {
      if (this.$store.state.initialData.currents) {
        const arr = this.$store.state.initialData.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.video.current
          ) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return { id: 0 };
    },

    level() {
      if (Array.isArray(this.$store.state.initialData.levels)) {
        const arr = this.$store.state.initialData.levels.filter(l => {
          if (l.value === this.video.videoLvl) {
            return true;
          }
          return false;
        });
        if (arr[0]) {
          return arr[0].label;
        }
      }
      return ``;
    },

    focus() {
      const focus = [];
      let output = ``;
      if (Array.isArray(this.initialData.focus)) {
        this.initialData.focus.forEach(f => {
          if (Array.isArray(this.video.equip)) {
            this.video.equip.forEach(item => {
              if (item.tag === f.id) {
                focus.push(f);
              }
            });
          }
        });
      }

      if (focus.length > 0) {
        focus.forEach(foption => {
          output = `${output} ${foption.label} |`;
        });
      }

      return output;
    },

    teacher() {
      if (this.$store.state.initialData.teachers) {
        const arr = this.$store.state.initialData.teachers.filter(t => {
          if (t.id === this.video.videoTeacher) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return { id: 0 };
    },

    equipment() {
      const list = [];
      if (Array.isArray(this.initialData.equipment)) {
        this.initialData.equipment.forEach(t => {
          this.video.equip.forEach(item => {
            if (item.tag === t.id) {
              list.push(t);
            }
          });
        });
      }
      return list;
    },
  },
};
</script>

<style lang="scss">
$purple: #656b85;

.main-video-container {
  position: relative;
}
.main-video-header {
  position: absolute;
  top: 0;
  width: 100%;
  max-width: 1240px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 100;
  color: $purple;
  font-size: 21px;
}
</style>
